import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

//component:
import CentroCajas from './centro_cajas';
import CentroZonas from './centro_zonas';
import CentroContab from './centro_contab';
import CentroZonaIva from './centro_zonaiva';
import CentroActionButtons from './centro_action_buttons';
import CentroCentros from './centro_centros';

//actions:
import { navigate, openDialog, hideDialog, setSaveState } from '../../actions';
import { getCentroDetalle, modifyFieldDetalleCentro, modifyFieldsCentroDialog } from '../../actions/centro_actions';
import { getTiposZona } from '../../actions/tipos_zona_actions';
import { getTiposMaquina } from '../../actions/tipos_maquina_actions';
import { getEmpresas } from '../../actions/empresa_actions';
import { getTiposZonasIva } from '../../actions/zona_iva_centro_actions';

import * as config from '../../constants/configuration';

import { getData } from '../../dataLib';


const styles = theme => ({
    toolbar: {
        display: 'block',
        minHeight: 112,
        marginBottom: 15,
    },
    formControl: {
        margin: '5px 0px 5px 20px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    grid: {
        padding: '0 12px',
        width: '100%',
    },
    icon: {
        margin: '0 auto',
        height: 50,
        width: 50,
        boxShadow: 'none',
        color: 'white'
    },
    buttonAtras: {
        margin: theme.spacing(1),
        height: 40,
        width: 123,
        padding: '10px',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
    buttonIcon: {
        marginLeft: theme.spacing(2),
        borderRadius: 0,
        border: 'none',
        boxShadow: 'none',
        height: 48
    },
});

class CentroEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            descr: '',
            direccion1: '',
            direccion2: '',
            cp: '',
            localidad: '',
            iDiaCierre: 0,
            canal: '',
            activo: 0,
            empresaId: -1
        };
    };

    componentDidMount() {
        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getCentroDetalle(this.props.match.params.id);
        this.props.getTiposZona();
        this.props.getTiposMaquina();
        this.props.getEmpresas();
        this.props.getTiposZonasIva();
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.centroDetalle !== this.props.centroDetalle) {
            this.setState({
                descr: this.props.centroDetalle.descr ? this.props.centroDetalle.descr : '',
                direccion1: this.props.centroDetalle.direccion1 ? this.props.centroDetalle.direccion1 : '',
                direccion2: this.props.centroDetalle.direccion2 ? this.props.centroDetalle.direccion2 : '',
                cp: this.props.centroDetalle.cp ? this.props.centroDetalle.cp : '',
                localidad: this.props.centroDetalle.localidad ? this.props.centroDetalle.localidad : '',
                iDiaCierre: this.props.centroDetalle.iDiaCierre ? this.props.centroDetalle.iDiaCierre : 0,
                canal: this.props.centroDetalle.canal ? this.props.centroDetalle.canal : 0,
                activo: this.props.centroDetalle.activo || 0,
                empresaId: this.props.centroDetalle.empresaId
            });
        }

        if ((prevProps.updated !== this.props.updated) && this.props.updated) this.props.navigate("mae_centro")
    };

    createEmpresaSelectOptions = () => {
        return this.props.empresas.map((emp, index) => {
            return (
                <option key={emp.id} value={emp.id}>{emp.empresa1}</option>
            );
        });
    };

    handleEmpresaSelectChange = (event) => {
        const value = parseInt(event.target.value);
        this.setState({ ...this.state, empresaId: value });
    }

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };

    onBlur = (event, field) => {

        //const value = event.target.value;
        const value = this.state[field];

        if (this.props.centroDetalle[field] !== value) {
            this.props.setSaveState(true);
            this.props.modifyFieldDetalleCentro(field, value);
        }
    };



    //checkbox:
    handleCheckboxChange = e => {
        const value = e.target.checked;

        this.props.setSaveState(true);
        this.props.modifyFieldDetalleCentro('activo', (value ? 1 : 0));

        this.setState({ ...this.state, activo: value ? 1 : 0 });
    };

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkMoreDetailsDialog = (centro) => {
        //email regular expression:
        // var re = /[^@]+@[^@]+\.[^@]+/;

        // if (centro.emailCentro && !re.test(centro.emailCentro)) {
        //     this.messageDialog('El Email introducido no es válido');
        //     return false;
        // }

        // else return true;

        return true;

    };

    //more centro details dialog:
    moreDetailsDialog = () => {

        // obtiene el inventario
        let URL = 'CvProvincias';

        this.setState({ ...this.state, showSpinner: true });

        if (this.state.provinciaList) {
            this.props.openDialog('MoreDetailsCentro', {
                centroDetalle: this.props.centroDetalle,
                modifyFieldsCentroDialog: this.props.modifyFieldsCentroDialog,
                checkMoreDetailsDialog: this.checkMoreDetailsDialog,
                provinciaList: this.state.provinciaList,
                openDialog: this.props.openDialog,
                user: this.props.user
            }, uuidv4(), false, 'md');
        } else {
            getData(URL,
                (response) => {
                    this.setState({ ...this.state, showSpinner: false, provinciaList: response.data });
                    this.props.openDialog('MoreDetailsCentro', {
                        centroDetalle: this.props.centroDetalle,
                        modifyFieldsCentroDialog: this.props.modifyFieldsCentroDialog,
                        checkMoreDetailsDialog: this.checkMoreDetailsDialog,
                        provinciaList: response.data,
                        openDialog: this.props.openDialog,
                        user: this.props.user
                    }, uuidv4(), false, 'md');
                },
                (error) => {
                    this.props.openDialog('SimpleMessage', {
                        message: 'ERROR fetching provincias'
                    }, 'centro_edut', false, 'sm');
                    this.setState({ ...this.state, showSpinner: false });
                },
                this.props.user
            );
        }
    };


    goBack = () => {
        if (this.props.saveState.pending) {
            this.props.openDialog('ConfirmationDialog', {
                message: 'Existen cambios no guardados. Desea abandonar la sección y perder los cambios?',
                acceptHandler: () => {
                    this.props.setSaveState(false);
                    this.props.navigate("mae_centro");
                }
            }, 'left-drawer-confirmation-message', false, 'sm');
        }
        else {
            this.props.navigate("mae_centro");
        }
    }


    render() {

        const { classes } = this.props;

        if (!this.props.centroDetalle || !this.props.tiposZona) {

            return (<div></div>);

        };

        return (
            <div>
                <div className={classes.toolbar} />
                <Grid container spacing={24}>
                    <form>
                        {/* <Button className={classes.buttonAtras} variant="contained" color="secondary" onClick={() => this.props.navigate("mae_centro")}>Atrás</Button> */}
                        <IconButton className={classes.buttonIcon} variant="contained" color="secondary" onClick={this.goBack}> <Icon>keyboard_backspace</Icon></IconButton>
                        <div className={classes.containerPair}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    id='nombre'
                                    label='Nombre'
                                    placeholder='Nombre'
                                    autoFocus
                                    value={this.state.descr}
                                    onChange={(event) => this.handleValueChange(event, 'descr')}
                                    onBlur={(event) => this.onBlur(event, 'descr')}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'descr') }; }}
                                />
                            </FormControl>

                            <FormControl className={classes.formControl}>
                                <InputLabel htmlFor="empresa-placeholder">Empresa: </InputLabel>
                                <Select
                                    native
                                    value={this.state.empresaId}
                                    onChange={(event) => this.handleEmpresaSelectChange(event)}
                                    onBlur={(event) => this.onBlur(event, 'empresaId')}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'empresaId') }; }}
                                    name="empresaId"
                                >
                                    {this.createEmpresaSelectOptions()}
                                </Select>
                            </FormControl>
                        </div>

                        <div className={classes.containerPair}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    id='direccion1'
                                    label='Dirección 1'
                                    placeholder='Dirección'
                                    value={this.state.direccion1}
                                    onChange={(event) => this.handleValueChange(event, 'direccion1')}
                                    onBlur={(event) => this.onBlur(event, 'direccion1')}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'direccion1') }; }}
                                />
                            </FormControl>

                            <FormControl className={classes.formControl}>
                                <TextField
                                    id='direccion2'
                                    label='Dirección 2'
                                    placeholder='Dirección'
                                    value={this.state.direccion2}
                                    onChange={(event) => this.handleValueChange(event, 'direccion2')}
                                    onBlur={(event) => this.onBlur(event, 'direccion2')}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'direccion2') }; }}
                                />
                            </FormControl>
                        </div>

                        <div className={classes.containerPair}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    id='cp'
                                    label='CP'
                                    value={this.state.cp}
                                    onChange={(event) => this.handleValueChange(event, 'cp')}
                                    onBlur={(event) => this.onBlur(event, 'cp')}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'cp') }; }}
                                />
                            </FormControl>

                            <FormControl className={classes.formControl}>
                                <TextField
                                    id='localidad'
                                    label='Localidad'
                                    value={this.state.localidad}
                                    onChange={(event) => this.handleValueChange(event, 'localidad')}
                                    onBlur={(event) => this.onBlur(event, 'localidad')}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'localidad') }; }}
                                />
                            </FormControl>
                        </div>

                        <div className={classes.containerPair}>
                            <FormControl className={classes.formControl}>
                                <InputLabel htmlFor="dia-cierre-placeholder">
                                    Día de cierre
                                </InputLabel>
                                <Select
                                    value={this.state.iDiaCierre}
                                    onChange={(event) => this.handleValueChange(event, 'iDiaCierre')}
                                    onBlur={(event) => this.onBlur(event, 'iDiaCierre')}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'iDiaCierre') }; }}
                                    name="iDiaCierre"
                                >
                                    <MenuItem value={1}>Lunes</MenuItem>
                                    <MenuItem value={2}>Martes</MenuItem>
                                    <MenuItem value={3}>Miércoles</MenuItem>
                                    <MenuItem value={4}>Jueves</MenuItem>
                                    <MenuItem value={5}>Viernes</MenuItem>
                                    <MenuItem value={6}>Sábado</MenuItem>
                                    <MenuItem value={0}>Domingo</MenuItem>
                                </Select>
                            </FormControl>

                            <FormControl className={classes.formControl}>
                                <TextField
                                    id='canal'
                                    label='Cuenta analítica'
                                    value={this.state.canal}
                                    onChange={(event) => this.handleValueChange(event, 'canal')}
                                    onBlur={(event) => this.onBlur(event, 'canal')}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'canal') }; }}
                                />
                            </FormControl>
                        </div>


                        <div className={classes.containerPair}>
                            <FormControl className={classes.formControl}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.activo ? true : false}
                                            onChange={this.handleCheckboxChange}
                                        />
                                    }
                                    label="Activo"
                                />
                            </FormControl>

                            {/* <FormControl className={classes.formControl}>
                                <Tooltip title="Acceso a más datos del centro" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} placement="right" classes={{ tooltip: this.props.classes.tooltip }}>
                                    <Fab className={classes.icon} color="primary" onClick={this.moreDetailsDialog} >+</Fab>
                                </Tooltip>
                            </FormControl> */}

                            <FormControl className={classes.formControl}>
                                <Button className={classes.buttonAtras} variant="contained" color="primary" onClick={this.moreDetailsDialog}>Más datos</Button>
                            </FormControl>

                            <FormControl className={classes.formControl}>
                                <Button className={classes.buttonAtras} variant="contained" color="secondary" onClick={() => {
                                    this.props.openDialog('CentroMailing', {
                                        centroId: this.props.match.params.id
                                    }, 'edit_centro_mailing_list', false, "md")
                                }}>Mailing</Button>
                            </FormControl>

                        </div>


                    </form>

                    {this.props.centroDetalle.isGroup ?
                        <div className={classes.grid}>
                            <CentroCentros centroid={parseInt(this.props.match.params.id)} />
                        </div>
                        :
                        <div className={classes.grid}>
                            <div className={classes.grid}>
                                <CentroCajas centroid={parseInt(this.props.match.params.id)} />
                            </div>
                            <div className={classes.grid}>
                                <CentroZonas centroid={parseInt(this.props.match.params.id)} />
                            </div>
                            <div className={classes.grid}>
                                <CentroZonaIva centroid={parseInt(this.props.match.params.id)} />
                            </div>
                            <div className={classes.grid}>
                                <CentroContab centroid={parseInt(this.props.match.params.id)} />
                            </div>
                        </div>
                    }
                    <div className={classes.grid}>
                        <CentroActionButtons backHandler={this.goBack} />
                    </div>

                </Grid>
            </div>
        );

    };

};

CentroEdit.propTypes = {
    //state
    centroDetalle: PropTypes.object.isRequired,
    modifyFieldDetalleCentro: PropTypes.func.isRequired,
    modifyFieldsCentroDialog: PropTypes.func.isRequired,
    tiposZona: PropTypes.object.isRequired,
    tiposMaquina: PropTypes.array.isRequired,
    empresas: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    updated: PropTypes.bool.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    getCentroDetalle: PropTypes.func.isRequired,
    getTiposZona: PropTypes.func.isRequired,
    getTiposMaquina: PropTypes.func.isRequired,
    getEmpresas: PropTypes.func.isRequired,
    getTiposZonasIva: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        centroDetalle: state.centroDetalle.centrodetalle,
        updated: state.centroDetalle.updated,
        tiposZona: state.tiposZona,
        tiposMaquina: state.tiposMaquina.tiposmaquina,
        empresas: state.empresas.empresas,
        user: state.oidc.user,
        saveState: state.saveState,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        navigate,
        openDialog,
        hideDialog,
        getCentroDetalle,
        modifyFieldDetalleCentro,
        modifyFieldsCentroDialog,
        getTiposZona,
        getTiposMaquina,
        getEmpresas,
        getTiposZonasIva,
        setSaveState
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles, { withTheme: true })(CentroEdit)));
